import axiosInstance from '../axiosInterceptor/axiosInstance'

const impersonateUser = (data) => {
  const { email } = data
  const url = `/auth/impersonate?email=${encodeURIComponent(email)}`

  return axiosInstance.post(url, null, { withCredentials: true })
}

export default impersonateUser
